var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgInvoiceOverdueV1 = function SvgInvoiceOverdueV1(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Invoice-Overdue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.15,9.66v51a1.27,1.27,0,0,1-1.3,1.23H6.61a1.26,1.26,0,0,1-1.3-1.23c0-15.62,0-32.15,0-47.71V2.86A1.53,1.53,0,0,1,6.87,1.37H52.59a1.53,1.53,0,0,1,1.56,1.49Z",
    style: {
      fill: "#edfdfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.59,38.08H14.05a1.22,1.22,0,1,1,0-2.44H29.18a1.22,1.22,0,1,1,0,2.44Z",
    style: {
      fill: "#e5e8f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.67,29.18h15.4a5.27,5.27,0,0,1,.69,0,1.18,1.18,0,0,1,1,1.25,1.15,1.15,0,0,1-1,1.16,3.11,3.11,0,0,1-.61,0h-31a4.15,4.15,0,0,1-.61,0,1.18,1.18,0,0,1-1-1.25,1.15,1.15,0,0,1,1-1.16,4,4,0,0,1,.69,0Z",
    style: {
      fill: "#e5e8f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,44H13.87a1.22,1.22,0,1,1,0-2.44H29.17c.85,0,1.29.42,1.3,1.21A1.14,1.14,0,0,1,29.18,44Z",
    style: {
      fill: "#e5e8f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,49.84H13.87a1.22,1.22,0,1,1,0-2.44H29.17c.85,0,1.29.42,1.3,1.21a1.14,1.14,0,0,1-1.29,1.23Z",
    style: {
      fill: "#e5e8f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.16,34.6a14,14,0,1,0,5.36,1.07A14.05,14.05,0,0,0,48.16,34.6Zm0,21a1.42,1.42,0,0,1-.78-.23,1.37,1.37,0,0,1-.51-.63,1.33,1.33,0,0,1-.08-.81,1.38,1.38,0,0,1,1.1-1.1,1.39,1.39,0,0,1,1.43.59,1.38,1.38,0,0,1,.24.78,1.41,1.41,0,0,1-.41,1A1.37,1.37,0,0,1,48.16,55.62Zm1.4-5.6a1.4,1.4,0,1,1-2.8,0V43a1.4,1.4,0,1,1,2.8,0Z",
    style: {
      fill: "#ff656f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.53,11.79c0,.94.72,1.58,2,1.6a4.11,4.11,0,0,1,4.09,3.13,4,4,0,0,1-2.26,4.6c-.54.24-.83.45-.79,1.08a1,1,0,0,1-1.08,1.17,1.08,1.08,0,0,1-1.17-1.2A1,1,0,0,0,28.58,21a3.35,3.35,0,0,1-1.72-1.81,1,1,0,0,1,.42-1.53,1.07,1.07,0,0,1,1.61.45,1.78,1.78,0,0,0,1.89,1.12,1.94,1.94,0,0,0,1.7-1.85,1.83,1.83,0,0,0-1.92-1.71,4,4,0,0,1-3.92-2.29,3.91,3.91,0,0,1,1.74-5.32c.58-.28,1-.54.95-1.31A1.06,1.06,0,0,1,30.45,5.7a1,1,0,0,1,1.1,1.07,1.26,1.26,0,0,0,1,1.4A3.41,3.41,0,0,1,34,9.8a1.09,1.09,0,0,1-.52,1.66c-.65.35-1.12.08-1.48-.53-.58-1-1.17-1.25-2.08-1A1.69,1.69,0,0,0,28.53,11.79Z",
    style: {
      fill: "#e5e8f6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "RncJR1.tif"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.53,28.46c0-.19,0-.38,0-.58a3.73,3.73,0,0,1,7.37-.59,3.73,3.73,0,0,1-7,2.42c-.06-.12-.13-.24-.2-.36Zm4.3,1.92a2.38,2.38,0,0,0,1.78-2.86A2.38,2.38,0,1,0,8,28.61,2.38,2.38,0,0,0,10.83,30.38Z",
    style: {
      fill: "#ff656f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.13,23.88l1.95,1.38c.29.21.47.51.27.82a1.08,1.08,0,0,1-.63.42c-.15,0-.37-.12-.53-.23-.77-.53-1.54-1.08-2.41-1.58.1.41.19.81.29,1.21,0,.2.1.39.12.58a.65.65,0,0,1-.53.78.62.62,0,0,1-.77-.53c-.29-1.2-.58-2.4-.86-3.6-.18-.73-.35-1.45-.52-2.18-.13-.54,0-.81.56-.95a16.35,16.35,0,0,1,1.65-.38A2.27,2.27,0,0,1,32.27,21a2.25,2.25,0,0,1-.87,2.66ZM29,21.12l.43,1.8c.36-.08.69-.14,1-.24a1,1,0,0,0,.65-1,.9.9,0,0,0-.93-.71A11,11,0,0,0,29,21.12Z",
    style: {
      fill: "#ff656f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.79,18.34c-.48.1-.95.22-1.43.34s-.76.43-.62,1c.2.88.42,1.75.62,2.63s.42,1.77.64,2.66c.18.72.44.88,1.15.71l1.28-.31a2.87,2.87,0,0,0,2.26-2.31A4.47,4.47,0,0,0,39.21,20,2.94,2.94,0,0,0,35.79,18.34Zm2.63,4.13A1.58,1.58,0,0,1,37,24.12l-.81.2c-.35-1.45-.68-2.82-1-4.2a.39.39,0,0,1,.2-.32A1.85,1.85,0,0,1,38.19,21,4,4,0,0,1,38.42,22.47Z",
    style: {
      fill: "#ff656f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1,19.82c-.16-.65-.32-1.3-.47-1.95s.06-.88.49-1,.69.12.81.64l.9,3.74a1.36,1.36,0,0,0,1.72,1.06,1.38,1.38,0,0,0,1.12-1.74c-.29-1.24-.59-2.49-.89-3.73-.12-.53,0-.84.44-1s.73.11.86.65c.31,1.27.63,2.54.91,3.82a2.8,2.8,0,0,1-5.46,1.26C41.38,21,41.24,20.43,41.1,19.82Z",
    style: {
      fill: "#ff656f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9,19.33,50.29,21l1.47-.34a2,2,0,0,1,.53-.08.61.61,0,0,1,.63.55.59.59,0,0,1-.44.71c-.87.23-1.75.45-2.63.63a.61.61,0,0,1-.73-.53c-.47-1.94-.94-3.88-1.39-5.83a.65.65,0,0,1,.51-.84c.81-.21,1.63-.4,2.45-.58A.67.67,0,1,1,51,16c-.57.15-1.15.28-1.76.43L49.6,18c.52-.12,1-.26,1.55-.36s1.07.35.83.86a.92.92,0,0,1-.53.43C51,19.11,50.45,19.2,49.9,19.33Z",
    style: {
      fill: "#ff656f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2,25.46l.39,1.64,1.51-.35a2,2,0,0,1,.54-.07.6.6,0,0,1,.58.59.58.58,0,0,1-.43.67c-.87.23-1.74.44-2.62.63a.62.62,0,0,1-.74-.53c-.12-.47-.23-.95-.35-1.42l-1-4.18c-.17-.72,0-1,.71-1.14s1.36-.33,2.05-.48c.51-.12.84,0,.94.45s-.11.72-.64.86l-1.64.39.39,1.63,1.5-.36a.69.69,0,0,1,.88.37.64.64,0,0,1-.47.91C25.3,25.21,24.78,25.32,24.2,25.46Z",
    style: {
      fill: "#ff656f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.61,27.34c.14-1.62.26-3.09.42-4.55a1,1,0,0,1,.37-.67c.49-.29,1,.11.94.72-.12,1.52-.25,3-.38,4.55-.05.53-.09,1.07-.14,1.6a.8.8,0,0,1-.61.77.79.79,0,0,1-.93-.4L15,24.16a.68.68,0,0,1,.12-1c.37-.24.75-.13,1,.32l2.16,3.39Z",
    style: {
      fill: "#ff656f"
    }
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInvoiceOverdueV1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Invoice_Overdue_v1.9ae26b7e.svg";
export { ForwardRef as ReactComponent };